import { createContext, useContext } from 'react';
import type { DocumentsResource } from '@mrrmlab/api-client';

const DocumentsApiContext = createContext<DocumentsResource | null>(null);

export const DocumentsApiProvider = DocumentsApiContext.Provider;

export function useDocumentsApi(): DocumentsResource {
  const ctx = useContext(DocumentsApiContext);
  if (!ctx) throw new Error('useDocumentsApi called outside <DocumentsApiProvider>');
  return ctx;
}
